<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_525_1157)">
      <path
        d="M39.25 20.7798C38.93 22.3798 38.72 24.0098 38.27 25.5698C35.54 34.9098 26.33 40.8398 16.78 39.4598C7.29 38.0798 0.169996 30.0198 -4.49223e-06 20.4798C-0.170004 10.7198 6.72 2.37984 16.3 0.759844C17.24 0.599844 18.2 0.479844 19.14 0.339844C19.37 0.339844 19.59 0.339844 19.82 0.339844C20.32 0.429844 20.81 0.559844 21.31 0.609844C29.49 1.38984 36.24 7.02984 38.39 14.9398C38.76 16.2898 38.96 17.6898 39.23 19.0698C39.23 19.6398 39.23 20.2098 39.23 20.7698L39.25 20.7798ZM1.02 20.0498C1.02 30.3098 9.21 38.5498 19.47 38.5798C29.76 38.6198 38.13 30.2598 38.08 19.9998C38.03 9.78984 29.69 1.48984 19.51 1.51984C9.29 1.53984 1.02 9.81984 1.02 20.0498Z"
        fill="currentColor"
      />
      <path
        d="M26.54 18.5889C24.94 17.0989 23.34 15.6189 21.75 14.1089C21.18 13.5689 20.39 12.8989 21.3 12.1789C21.6 11.9389 22.69 12.2689 23.11 12.6689C25.6 15.0489 28.01 17.5189 30.51 20.0289C27.83 22.7389 25.23 25.4089 22.56 28.0089C22.3 28.2589 21.58 28.0289 21.07 28.0189C21.14 27.5189 21.02 26.8389 21.31 26.5389C22.96 24.8189 24.7 23.1989 26.71 21.2489C25.83 21.1789 25.38 21.1089 24.92 21.1089C20.21 21.1089 15.51 21.1389 10.8 21.0589C10.17 21.0489 9.05 20.5089 9.02 20.1289C8.89 18.8589 10.03 19.0689 10.84 19.0589C15.43 19.0489 20.02 19.0589 24.62 19.0589C25.16 19.0589 25.7 19.0589 26.24 19.0589C26.34 18.8989 26.44 18.7389 26.54 18.5889Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_525_1157">
        <rect
          width="39.25"
          height="39.32"
          fill="white"
          transform="translate(0 0.339844)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'CollaborationArrow',
  }
</script>
